




































































































import Vue from 'vue'
import Component from "vue-class-component";
import {Action} from "vuex-class";
import {cloneDeep, isEqual} from "lodash";
import {SoundItem} from "@/store/call/sounds/types";
import {notifyConfirm, notifyDelete, notifyError} from '@/utils/notify-helper';
import {Ref, Watch} from "vue-property-decorator";
import {MsgTransports} from "@/store/types";
import {md5} from "pure-md5";
import {getTranslatedParams} from "@/utils/notify-utils";
import {ActionLog} from "@/store/auth/types";
import {PartnerItem} from "@/store/settings/partners/types";
import {SelectWings, InputWings, TextareaWings} from "wings-ui-components";
import { Route } from 'vue-router';

Component.registerHooks([
  'beforeRouteLeave',
])

@Component({
  components: {SelectWings, InputWings, TextareaWings}
})
export default class CallSound extends Vue {
  @Ref('validator') validator:any;

  @Action("getSoundItem") actionGetItem: any;
  @Action("deleteSound") actionDelete: any;
  @Action("uploadSound") actionUploadFile: any;
  @Action('actionLog') actionLog: any;
  @Action("getPartners") actionGetPartners: any;
  @Action("getPartnerUsers") actionGetPartnerUsers: any;

  partnersList: PartnerItem[] = [];
  partnerUsersList: any[] = [];
  transport: MsgTransports = MsgTransports.CALL;
  file: File | undefined = undefined;


  defaultItem(): SoundItem {
    return {
      name: "",
      path: "",
      partner_id: null,
      partner_user_id: null,
    };
  }

  private item = this.defaultItem();
  private itemSaved = this.defaultItem();
  private logObject: ActionLog = {};
  private isInitializing = false;
  private partnerUserDisplayName: string = '';

  get partnerUserName(): string {
    if (this.partnerUserDisplayName) return this.partnerUserDisplayName;
    if (this.item.partner_user_id === null || this.item.partner_user_id === undefined) {
      return this.$t('all') as string;
    }
    const id = Number(this.item.partner_user_id);
    const user = this.partnerUsersList.find((u: any) => Number(u.id) === id);
    return user?.name || user?.email || (this.$t('all') as string);
  }

  async getPartnersList(filter: any) {
    const items = await this.actionGetPartners({transport: this.transport, ...filter});
    this.partnersList = (filter?.page_number > 1) ? this.partnersList.concat(items) : items
  }

  async getPartnerUsersList(filter: any) {
    if (!this.item.partner_id) {
      this.partnerUsersList = [];
      return;
    }
    const items = await this.actionGetPartnerUsers({partner_id: this.item.partner_id, ...filter});
    this.partnerUsersList = (filter?.page_number > 1) ? this.partnerUsersList.concat(items) : items
  }

  async created() {
    if (this.$route.params.id) {
      try {
        this.logObject = {
          action_page: this.$route.meta.msgKey,
          action: 'Viewing',
          action_status: 'success',
          object_type: 'Sound library',
          addititional_info: getTranslatedParams({ id: this.$route.params.id })
        };
        await this.actionLog(this.logObject);
        this.isInitializing = true;
        const data = await this.actionGetItem(this.$route.params.id);
        this.item = Object.assign({}, this.item, data);
        if (this.item.partner_id) {
          this.partnersList = await this.actionGetPartners({ id: this.item.partner_id });
          this.partnerUsersList = await this.actionGetPartnerUsers({ partner_id: this.item.partner_id });
          if (this.item.partner_user_id !== null && this.item.partner_user_id !== undefined) {
            const id = Number(this.item.partner_user_id);
            const user = this.partnerUsersList.find((u: any) => Number(u.id) === id);
            this.partnerUserDisplayName = user?.name || user?.email || '';
          } else {
            this.partnerUserDisplayName = this.$t('all') as string;
          }
        }
        this.itemSaved = cloneDeep(Object.assign({}, this.item, data));
      } catch (error) {
        await this.actionLog({...this.logObject, action_status: "failed"});
      } finally {
        this.isInitializing = false;
      }
    }
  }

  back():void{
    this.$router.push('/call/sound_library');
  }

  async onSaveItem(): Promise<void> {
    const valid = await this.validator.validate();
    if (!valid) {
      setTimeout(() => {
        notifyError(null, this.validator.errors)
      }, 100);
      return;
    }

    try {
      if (!this.item.id) {
        await this.uploadSoundFile(this.file);
        await this.actionLog({
          action_page: this.$route.meta.msgKey,
          action: 'Creation',
          action_status: 'success',
          object_type: 'Sound library',
          addititional_info: getTranslatedParams(this.item)
        });
        this.itemSaved = cloneDeep(this.item);
      }
      this.back();
    } catch (e) {
      notifyError(e);
    }
  }

  async onDeleteItem():Promise<void> {
    let isConfirm:boolean = await notifyDelete();
    if (isConfirm) {
      try {
        await this.actionLog({
          action_page: this.$route.meta.msgKey,
          action: 'Removal',
          action_status: 'success',
          object_type: 'Sound library',
          addititional_info: getTranslatedParams({ id: this.item.id })
        });
        await this.actionDelete(this.item);
        this.itemSaved = this.item;
        this.back();
      } catch (error) {
        await this.actionLog({...this.logObject, action_status: "failed"});
        notifyError(error);
      }
    }
  }

  onFilePicked(file: File) {
    this.file = file;
    if (file) {
      this.item.name = file.name;
    }
  }

  private async uploadSoundFile(file?: File) {
    if (!file) {
      throw new Error('No file selected');
    }

    const readPromise = new Promise<Uint8Array>((resolve, reject) => {
      const fr = new FileReader();
      fr.onerror = (error) => reject(error);
      fr.onload = () => resolve(new Uint8Array(fr.result as ArrayBuffer));
      fr.readAsArrayBuffer(file);
    });

    const byteArray: Uint8Array = await readPromise;

    let fileString: string = '';
    const len = byteArray.byteLength;
    for (let i = 0; i < len; i++) {
      fileString += String.fromCharCode(byteArray[i]);
    }

    const base64String = btoa(fileString);
    const md5Hash = md5(fileString);

    const request: any = {
      name: this.item.name,
      base64: base64String,
      md5: md5Hash
    };

    if (this.item.partner_id !== null && this.item.partner_id !== undefined) {
      request.partner_id = this.item.partner_id;
    }

    if (this.item.partner_user_id !== null && this.item.partner_user_id !== undefined) {
      request.partner_user_id = this.item.partner_user_id;
    }

    return await this.actionUploadFile(request);
  }

  @Watch('item.partner_id')
  onPartnerChange() {
    // На просмотре не трогаем partner_user_id и не дергаем лишний запрос.
    if (this.$route.params.id || this.item.id || this.isInitializing) return;
    this.item.partner_user_id = null;
    this.partnerUserDisplayName = '';
    this.partnerUsersList = [];
    if (this.item.partner_id) {
      this.getPartnerUsersList({});
    }
  }

  beforeRouteLeave(to: Route, from: Route, next: any) {
    let isChange = !isEqual(this.item,this.itemSaved);
    notifyConfirm(isChange, this.onSaveItem, next);
  }
}
